var $ = global.jQuery = global.$;
require('velocity-animate');

var Form = require('./Form');

var Search = Form.extend({
  init: function() {
    var self = this;

    //Call the parent widgets own init method
    this._super();

    this.$searchToggle = this.$el.find('[data-search-toggle]');
    this.$searchOverlay = this.$el.find('[data-search-overlay]');
    this.$searchHeader = this.$el.find('[data-search-header]');

    this.$searchInput = this.$searchHeader.find('input');

    this.$searchIcon = this.$searchToggle.find('.icon');

    this.classes = {
      open: 'is-open',
      searchIcon: 'icon--search',
      closeIcon: 'icon--close'
    };

    this.close();

    $(window).on('resize orientationchange', function() {
      self.$searchHeader.height(self.$searchToggle.outerHeight());
    });

    this.$searchToggle.on('click', function(event) {
      event.preventDefault();
      if (self.isOpen) {
        self.close();
      } else {
        self.open();
      }
    });
  },
  close: function() {
    var self = this;
    this.$searchToggle.removeClass(this.classes.open);
    this.$searchIcon.removeClass(this.classes.closeIcon);
    this.$searchIcon.addClass(this.classes.searchIcon);
    this.$searchOverlay.velocity({
      'scaleX': 0
    }, {
      'display': 'none',
      complete: function() {
        self.isOpen = false;
        self.$el.removeClass(self.classes.open);
      }
    });
  },
  open: function() {
    var self = this;
    this.$searchToggle.addClass(this.classes.open);
    this.$searchIcon.removeClass(this.classes.searchIcon);
    this.$searchIcon.addClass(this.classes.closeIcon);
    this.$el.addClass(this.classes.open);
    this.$searchHeader.height(this.$searchToggle.outerHeight());
    this.$searchOverlay.velocity({
      'scaleX': 1
    }, {
      'display': 'block',
      complete: function() {
        self.isOpen = true;
        self.$searchInput.focus();
      }
    });
  }
});

module.exports = Search;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Search.js
// module id = 15
// module chunks = 0 1